// studentsAPI.js

// Function to fetch students
export const fetchStudents = async (token) => {
    try {
      const response = await fetch('https://test.creative-its.com/back/api/student/index', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Include the token in the request headers
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch students');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching students:', error);
      throw error;
    }
  };
  
  // Function to create a new student
  export const createStudent = async (token, studentData) => {
    try {
      const response = await fetch('https://test.creative-its.com/back/api/student/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Include the token in the request headers
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(studentData) // Convert studentData to JSON string
      });
  
      if (!response.ok) {
        throw new Error('Failed to create student');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error creating student:', error);
      throw error;
    }
  };
  // Function to update a student
export const updateStudent = async (token, studentId, updatedStudentData) => {
    try {
      const response = await fetch(`https://test.creative-its.com/back/api/student/update_student/${studentId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          // Include the token in the request headers
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(updatedStudentData) // Convert updatedStudentData to JSON string
      });
  
      if (!response.ok) {
        throw new Error('Failed to update student');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error updating student:', error);
      throw error;
    }
  };